module.exports ={
  "authService": "https://d3pfgllpgh.execute-api.us-east-1.amazonaws.com/prd",
  "authUiBaseUrl": "https://auth.domuso.com",
  "domusoApiService": "https://api.domuso.com",
  "dynamoStreamMachineService": "https://9nbdtrgtp1.execute-api.us-east-1.amazonaws.com/prd",
  "userPoolId": "us-east-1_2vMAPQtht",
  "userPoolClientId": "1k1mgbsu3hbu5eqfosmng9rga0",
  "vantivPaypageUrl": "https://request.eprotect.vantivcnp.com",
  "paypageId": "aArQsMfQNZkRWzfR",
  "reportGroup": "Default Report Group",
  "moneygramFlatFee": "395",
  "moneygramReservationCode": "Domuso (16479)",
  "paymentMaxAmount": "5000",
  "docGenerationService": "https://doc-generation.domuso.com",
  "mockScanData": "false",
  "datadog": {
    "clientToken": "pube26b2dd41ec89a32725b17d420e1d196",
    "isEnabled": "true"
  },
  "emailSupport": "support@domuso.com",
  "phoneSupport": "+1-424-396-1303",
  "fastlinkv4": {
    "url": "https://fl4.prod.yodlee.com/authenticate/USDevexProd3-272/fastlink?channelAppName=usdevexprod3",
    "config": "Verify"
  },
  "maintenanceUrl": "https://maintenance.domuso.com/maintenance_tag.json",
  "rewardService": "https://api-prd.domuso.com/reward",
  "env": "prd"
}